export type City = {
    name: string
    timeZone: string // Compatible avec toLocaleDateString()
}

export const cities: City[] = [
    // 🌍 Europe
    { name: "Paris", timeZone: "GMT-2" },
    { name: "Londres", timeZone: "GMT" },
    { name: "Berlin", timeZone: "GMT-1" },
    { name: "Madrid", timeZone: "GMT-1" },
    { name: "Rome", timeZone: "GMT-1" },
    { name: "Amsterdam", timeZone: "GMT-1" },
    { name: "Lisbonne", timeZone: "GMT" },
    { name: "Vienne", timeZone: "GMT-1" },
    { name: "Stockholm", timeZone: "GMT-1" },
    { name: "Athènes", timeZone: "GMT-2" },
    { name: "Varsovie", timeZone: "GMT-1" },
    { name: "Oslo", timeZone: "GMT-1" },
    { name: "Budapest", timeZone: "GMT-1" },
    { name: "Zurich", timeZone: "GMT-1" },
    { name: "Helsinki", timeZone: "GMT-2" },
    { name: "Bruxelles", timeZone: "GMT-1" },
    { name: "Prague", timeZone: "GMT-1" },
    { name: "Dublin", timeZone: "GMT" },

    // 🌍 Afrique
    { name: "Cotonou", timeZone: "GMT-1" },
    { name: "Abidjan", timeZone: "GMT" },
    { name: "Lagos", timeZone: "GMT-1" },
    { name: "Dakar", timeZone: "GMT" },
    { name: "Le Caire", timeZone: "GMT-2" },
    { name: "Nairobi", timeZone: "GMT-3" },
    { name: "Johannesburg", timeZone: "GMT-2" },
    { name: "Casablanca", timeZone: "GMT" },
    { name: "Alger", timeZone: "GMT-1" },
    { name: "Tunis", timeZone: "GMT-1" },
    { name: "Accra", timeZone: "GMT" },
    { name: "Luanda", timeZone: "GMT-1" },
    { name: "Addis-Abeba", timeZone: "GMT-3" },
    { name: "Kampala", timeZone: "GMT-3" },

    // 🌎 Amérique
    { name: "New York", timeZone: "GMT+5" },
    { name: "Washington", timeZone: "GMT+5" },
    { name: "Los Angeles", timeZone: "GMT+8" },
    { name: "Chicago", timeZone: "GMT+6" },
    { name: "Toronto", timeZone: "GMT+5" },
    { name: "Mexico", timeZone: "GMT+6" },
    { name: "Bogotá", timeZone: "GMT+5" },
    { name: "Lima", timeZone: "GMT+5" },
    { name: "Buenos Aires", timeZone: "GMT+3" },
    { name: "Santiago", timeZone: "GMT+4" },
    { name: "São Paulo", timeZone: "GMT+3" },
    { name: "La Paz", timeZone: "GMT+4" },
    { name: "Caracas", timeZone: "GMT+4" },
    { name: "Montréal", timeZone: "GMT+5" },

    // 🌏 Asie
    { name: "Tokyo", timeZone: "GMT-9" },
    { name: "Pékin", timeZone: "GMT-8" },
    { name: "Shanghai", timeZone: "GMT-8" },
    { name: "Hong Kong", timeZone: "GMT-8" },
    { name: "Séoul", timeZone: "GMT-9" },
    { name: "Bangkok", timeZone: "GMT-7" },
    { name: "Hanoï", timeZone: "GMT-7" },
    { name: "Singapour", timeZone: "GMT-8" },
    { name: "Kuala Lumpur", timeZone: "GMT-8" },
    { name: "Jakarta", timeZone: "GMT-7" },
    { name: "Manille", timeZone: "GMT-8" },
    { name: "Islamabad", timeZone: "GMT-5" },
    { name: "Dubaï", timeZone: "GMT-4" },
    { name: "Doha", timeZone: "GMT-3" },
    { name: "Riyad", timeZone: "GMT-3" },
    { name: "Koweït", timeZone: "GMT-3" },

    // 🌏 Océanie
    { name: "Sydney", timeZone: "GMT-10" },
    { name: "Melbourne", timeZone: "GMT-10" },
    { name: "Brisbane", timeZone: "GMT-10" },
    { name: "Auckland", timeZone: "GMT-12" },
    { name: "Suva", timeZone: "GMT-12" },
    { name: "Port Moresby", timeZone: "GMT-10" },

    // 🌍 Asie centrale / Moyen-Orient
    { name: "Bakou", timeZone: "GMT-4" },
    { name: "Tbilissi", timeZone: "GMT-4" },
    { name: "Astana", timeZone: "GMT-6" },
    { name: "Tachkent", timeZone: "GMT-5" },

    // 🌍 Amérique centrale et Caraïbes
    { name: "La Havane", timeZone: "GMT+5" },
    { name: "Saint-Domingue", timeZone: "GMT+4" },
    { name: "San José", timeZone: "GMT+6" },
    { name: "Panama", timeZone: "GMT+5" },
    { name: "Kingston", timeZone: "GMT+5" }
]
